import * as React from 'react';
import * as main from '../../main.module.scss';
import * as help from "./style.module.scss";
import { Modal } from "../../../../Modal";
export const Help = () => {
  const [showModalYulia, setShowModalYulia] = React.useState(false);
  const [showModalVage, setShowModalVage] = React.useState(false);
  const [showModalDmitriy, setShowModalDmitriy] = React.useState(false);
  return (
    <section className={help.help}>
      <div className="container">
        <h2 className={main.title}>Поможем вам, как помогли им:</h2>
        <ul>
          <li>
            <h3>Юлия Молчанова</h3>
            <button onClick={()=>{setShowModalYulia(true)}}>
              <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/kurshelp-01.png" alt=""/>
            </button>
            <div>
              <p>Работала в крупной компании</p>
              <p>После повышения <strong>половина писем</strong> по работе на английском языке</p>
              <p><strong>Трудности</strong> в коммуникации с коллегами</p>
              <p><strong>Освоила технику</strong> запоминания 100 слов в час</p>
              <p><strong>Подняла уровень</strong> английского</p>
              <p><strong>Свободно</strong> работает, путешествует и общается на английском языке</p>
            </div>
          </li>
          <li>
            <h3>Ваге Багдасарян</h3>
            <button onClick={()=>{setShowModalVage(true)}}>
              <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/kurshelp-02.png" alt=""/>
            </button>
            <div>
              <p><strong>Всю жизнь мечтал летать</strong></p>
              <p>Купил дорогое обучение на пилота и понял, что <strong>экзамены на английском</strong></p>
              <p><strong>За месяц</strong> улучшил язык, развил память и успешно сдал восемь экзаменов на летную лицензию (PPL)</p>
              <p><strong>Повысил уверенность</strong> в себе</p>
              <p><strong>Исполнил мечту</strong> и стал пилотом!</p>
            </div>
          </li>
          <li>
            <h3>Дмитрий</h3>
            <button onClick={()=>{setShowModalDmitriy(true)}}>
              <img src="https://fs.advance.ru/landing-pages/webinar/kak_vyuchit_anglijskij_mk/kurshelp-03.png" alt=""/>
            </button>
            <div>
              <p>До обучения в Advance учил язык долго <strong>и не эффективно</strong></p>
              <p><strong>После обучения</strong> запоминает по 400 новых слов в день</p>
              <p>Смог <strong>произвести впечатление</strong> на американских коллег</p>
            </div>
          </li>
        </ul>
        <div className={main.centeredBtnBlock}>
          <a href="#widget" className={main.btn}>Хочу так же</a>
        </div>
      </div>

      <Modal
        open={showModalYulia}
        onClose={() => {
          setShowModalYulia(false);
        }}
        maxWidth={'md'}
      >
        <div style={{width:"100%", padding:"30px"}}>
          <div style={{position:"relative",paddingTop:"56.25%"}}>
            <iframe
              title={'Отзыв Юлии Молчановой'}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%"
              }}
              allow="autoplay; encrypted-media"
              src="https://65395.servicecdn.ru/videos/65395_SWbXtG0oovPiok4z"
              allowFullScreen
            />
          </div>
        </div>
      </Modal>

      <Modal
        open={showModalVage}
        onClose={() => {
          setShowModalVage(false);
        }}
        maxWidth={'md'}
      >
        <div style={{width:"100%", padding:"30px"}}>
          <div style={{position:"relative",paddingTop:"56.25%"}}>
            <iframe
              title={'Отзыв Ваге Багдасаряна'}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%"
              }}
              allow="autoplay; encrypted-media"
              src="https://65395.servicecdn.ru/videos/65395_OTwRBgLuuZFh9Xtj"
              allowFullScreen
            />
          </div>
        </div>
      </Modal>

      <Modal
        open={showModalDmitriy}
        onClose={() => {
          setShowModalDmitriy(false);
        }}
        maxWidth={'md'}
      >
        <div style={{width:"100%", padding:"30px"}}>
          <div style={{position:"relative",paddingTop:"56.25%"}}>
            <iframe
              title={'Отзыв Дмитрия'}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%"
              }}
              allow="autoplay; encrypted-media"
              src="https://65395.servicecdn.ru/videos/65395_Q9OK7gsy6YgVUwN"
              allowFullScreen
            />
          </div>
        </div>
      </Modal>
    </section>
  );
};
